import {createSlice} from "@reduxjs/toolkit";

const initialGuiAwardsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  guiAwardForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const guiAwardsSlice = createSlice({
  name: "guiAwards",
  initialState: initialGuiAwardsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getGuiAwardById
    guiAwardFetched: (state, action) => {
      state.actionsLoading = false;
      state.guiAwardForEdit = action.payload.guiAwardForEdit;
      state.error = null;
    },
    // findGuiAwards
    guiAwardsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createGuiAward
    guiAwardCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.guiAward);
    },
    // updateGuiAward
    guiAwardUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.guiAwardId === action.payload.guiAward.guiAwardId) {
          return action.payload.guiAward;
        }
        return entity;
      });
    },
    // deleteGuiAward
    guiAwardDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.guiAwardId !== action.payload.guiAwardId);
    },
    // deleteGuiAwards
    guiAwardsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.guiAwardId)
      );
    },
  }
});
